import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { FunctionType } from "@/commons/models/Message";
import OtherUserGroupMessageModel from "@/commons/models/OtherUserGroupMessage";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 施設関係者メッセージ API 操作クラス
 */
export default class OtherUserGroupMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET OtherUserGroupMessages
   */
  public async gets(
    userStore: LoginUser,
    queryParams: {
      functionType: FunctionType;
      startIndex: number;
      endIndex: number;
      order: string;
      start: string;
      end: string;
    }
  ): Promise<Array<OtherUserGroupMessageModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl = UrlFormatter.format(RestUrl.OtherUserGroupMessages, formatParams);
    const response = await this.commonService.executeGet<Array<OtherUserGroupMessageModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      queryParams,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * GET OtherUserGroupMessagesCount
   */
  public async getCount(userStore: LoginUser, queryParams: { functionType: FunctionType }): Promise<number> {
    // countの場合は末尾に「count」をつける
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl = UrlFormatter.format(RestUrl.OtherUserGroupMessages, formatParams);
    const response = await this.commonService.executeGet<{ count: number }>(
      userStore,
      `${requestUrl}/count`,
      this.constructor.name,
      queryParams,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data.count;
  }

  /**
   * DELETE Messages
   */
  public async delete(userStore: LoginUser, datetime: number | string): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherUserGroupMessagesByDatetime, formatParams);
    const response = await this.commonService.executeDelete<any>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
